import { clearRegistrationUser } from 'utils/fns';
import { dedupedFetch } from './cache';
import { buscarIniciativasPorPlayer } from './iniciativa.service';

const CACHE_TTL_MS = 30_000;

const normalizeMatricula = (value?: string | null) =>
  clearRegistrationUser(String(value || ''));

const isCategoriaElbb = (categoryPremio?: string): boolean => {
  return String(categoryPremio || '').trim().toUpperCase() === 'ELBB';
};

const isUsuarioConfirmadoNaIniciativa = (ini: any, currentUserRegistration: string): boolean => {
  if (!currentUserRegistration) return false;

  const participanteAtual = Array.isArray(ini?.participantes)
    ? ini.participantes.find(
        (p: any) => normalizeMatricula(p?.matricula) === currentUserRegistration
      )
    : undefined;

  if (participanteAtual?.confirmado) return true;

  return Array.isArray(ini?.confirmedPlayers)
    ? ini.confirmedPlayers.some(
        (cp: string) => normalizeMatricula(cp) === currentUserRegistration
      )
    : false;
};

export const hasPendenciaInscricaoOuConfirmacaoElbb = (
  iniciativas: any[] = [],
  userId?: string
): boolean => {
  const currentUserRegistration = normalizeMatricula(userId);

  return iniciativas.some((ini) => {
    if (!isCategoriaElbb(ini?.categoryPremio)) return false;

    const status = String(ini?.status || '').toLowerCase();
    const precisaInscrever = status !== 'inscrita';
    const precisaConfirmarParticipacao =
      status === 'inscrita' && !isUsuarioConfirmadoNaIniciativa(ini, currentUserRegistration);

    return precisaInscrever || precisaConfirmarParticipacao;
  });
};

export const canAccessMinhasIniciativasElbb = async (userId?: string): Promise<boolean> => {
  if (!userId) {
    return false;
  }

  return dedupedFetch<boolean>(
    `minhas-iniciativas-elbb-eligibility:${userId}`,
    async () => {
      const iniciativas = await buscarIniciativasPorPlayer(userId, 'ELBB');
      return hasPendenciaInscricaoOuConfirmacaoElbb(iniciativas, userId);
    },
    CACHE_TTL_MS
  );
};
